import { render } from "./Errorfi.vue?vue&type=template&id=3bbdb6ee&scoped=true"
import script from "./Errorfi.vue?vue&type=script&lang=js"
export * from "./Errorfi.vue?vue&type=script&lang=js"

import "./Errorfi.vue?vue&type=style&index=0&id=3bbdb6ee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3bbdb6ee"

export default script